<template>
  <span class="icon--wrapper-file-satus"  v-if="isIconShow">
    <div  v-if="statusFile == 6"  @mouseover="handleMouseoverNotifiacation">
    <i :id="idAttr"
       class="icon icon--error"
       @click="handleOpenJobLogs"
       title="Rendering error"> </i>
    <b-tooltip v-if="notificationRequested" :target="idAttr">
      <div v-html="fileData"></div>
    </b-tooltip>
    </div>

     <div v-else-if="statusFile == 8">
      <i class="icon icon--spinner" v-b-tooltip.hover
         title="File processing..."> <i class="inner1"></i> <i
              class="inner2"></i> </i>
       <b-modal v-model="openJobLogs" title="FILE LOGS" size="lg">
        <file-jobs-log :file-id="fileId"></file-jobs-log>
        <template v-slot:modal-footer="{ cancel }">
          <div class="modal__footer--left">
            <b-button variant="-gray" @click="cancel()">
             {{$t('buttons.cancel')}}
            </b-button>
          </div>
        </template>
      </b-modal>
     </div>

  </span>
  <a v-else-if="hasIcon"
     :id="previewLinkId"
     href="javascript:void(0)"
     :class="iconClass"
     @click="handleClick"
     @mouseover="handleMouseover"
     @mouseleave="handleMouseleave">
    <img :src="iconSrc" class="model-preview-icon" />
    <b-tooltip v-if="hasPreview && !previewLoaded" :target="previewLinkId" triggers="hover">
      {{$t('files.typeTooltip.loading')}}
    </b-tooltip>
    <b-popover v-if="hasPreview" :disabled="!previewLoaded"
               ref="popover"
               custom-class="job-img-preview-popover"
               variant="dark"
               :target="previewLinkId"
               placement="top"
               triggers="hover focus">
      <template v-slot:title></template>
      <div>
        <b-img :src="previewSrc" width="340"></b-img>
      </div>
    </b-popover>
  </a>
  <span v-else @click="handleClick" class="files-page__preview--small no-image">
  </span>
</template>

<script>
  import {mapActions} from 'vuex';
  import FileJobsLog from "@/components/files/modal/FileJobsLog";

  export default {
    name: 'model-preview',
    components:{
      FileJobsLog
    },
    props: {
      fileId:{
        type: String
      },
      iconImg: {
        type: String
      },
      previewImg: {
        type: String
      },
      videoLink: {
        type: String
      },
      showVideoIcon: {
        type: Boolean,
        default: false
      },
      statusFile:{
        type: String,
        default: '0'
      }
    },
    data() {
      return {
        openJobLogs: false,
        uniqueId: `f${(~~(Math.random()*1e8)).toString(8)}`,
        previewLoaded: false,
        hovered: false,
        notificationRequested: false,
        notification: null,
        notificationLoaded: false,
      }
    },

    computed: {
      idAttr() {
        return 'file-type-error-tooltip-' + this.fileId;
      },
      iconSrc() {
        if (this.showVideoIcon && this.videoLink) {
          return window.as3Url + 'render/' + this.videoLink + '.square.png';
        }
        if (this.iconImg) {
          return window.as3Url + 'render/' + this.iconImg;
        }
        return '';
        //return window.cdnUrl + '/assets/i/ico/photo_ico_active.png';
      },
      iconClass() {
        return this.videoLink ? {'preview i-border': true} : {};
      },
      hasPreview() {
        return this.previewImg && this.previewImg.trim() !== '';
      },
      hasIcon() {
        return this.iconImg && this.iconImg.trim() !== '';
      },
      isIconShow(){
        return  [6, 8].indexOf(parseInt(this.statusFile)) > - 1;
      },
      previewSrc() {
        return window.as3Url + 'render/' + this.previewImg;
      },
      previewLinkId() {
        return 'job-preview--' + this.uniqueId;
      },
      fileData() {
        if (!this.notificationLoaded) {
          return 'Loading...';
        }else{
          return this.notificationRender(this.notification)
        }
      }
    },

    methods: {
      ...mapActions(['getFileNotification']),


      handleMouseoverNotifiacation() {
        if (!this.notificationRequested) {
          this.notificationRequested = true;
          this.getFileNotification(this.fileId).then(({data}) => {
            this.notificationLoaded = true;
            if (data.result) {
              this.notification = data.message;
            } else {
              this.notification = data.message;
            }
          });
        }
      },
      notificationRender(notification) {


        if(typeof notification != "object"){
          return notification
        }

        let hoverInfo = '';
        notification.forEach((key, item) => {
          if ( key > 0 ) hoverInfo += '<br/>';
          hoverInfo += item.name + ': ';
          if (item.status == 'f') hoverInfo += '<span style="color: red">error</span>';
          else hoverInfo += '<span style="color: green">ok</span>';
        });
        return hoverInfo;

      },
      handleOpenJobLogs(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.openJobLogs = true;
      },

      handleMouseover() {
        this.hovered = true;
        if (!this.hasPreview) {
          return;
        }
        if (!this.previewLoaded) {
          const image = new Image();
          image.onload = () => {
            this.previewLoaded = true;
            this.$nextTick(() => {
              this.$refs.popover.$emit('enable');
              if (this.hovered) {
                this.$refs.popover.$emit('open');
              }
            });
          };
          image.src = this.previewSrc;
        }
      },

      handleMouseleave() {
        this.hovered = false;
      },

      handleClick() {
        if (this.videoLink) {
          this.$emit('openTimelaps');
          if (!this.$refs.popover.disabled) {
            this.$refs.popover.$emit('disable');
            this.$refs.popover.$emit('close');
            this.$root.$on('bv::modal::hidden', this.onTimelapsModalHidden);
          }
        }
      },

      onTimelapsModalHidden() {
        setTimeout(() => {
          this.$refs.popover.$emit('enable');
        });
        this.$root.$off('bv::modal::hidden', this.onTimelapsModalHidden);
      }
    }
  }
</script>

<style scoped lang="scss">

    .job-img-preview-popover {
        max-width: 400px;
    }
    .icon--wrapper-file-satus > div{
        width: 40px;
        text-align: center;
        i{
            cursor: pointer !important;
        }
    }
    .files-page__preview--no-image{
        position: relative;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #daf7fb;
        display: inline-block;
    }
</style>
